module.exports = __webpack_public_path__ + "img/icon-file.fe3fd5e4.svg";